import { z } from "@core/zod";

const HttpMethodSchema = z.enum([
  "DELETE",
  "GET",
  "HEAD",
  "OPTIONS",
  "PATCH",
  "POST",
  "PUT",
]);

export type HttpMethod = z.infer<typeof HttpMethodSchema>;

export function isHttpMethod(value: string): value is HttpMethod {
  const parseResult = HttpMethodSchema.safeParse(value);

  return parseResult.success;
}
